import React, { useEffect, useState } from 'react';
import api from '../../utils/api';
import { useNavigate } from 'react-router-dom';
import { useToast } from '../../context/ToastContext';

export default function BatchAdd() {
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);

  const [form, setForm] = useState({
    programId: '',
    batch: '',
    startDate: '',
    endDate: '',
    statusOffered: false,
    isOpen: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm({
      ...form,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  useEffect(() => {
    const fetchPrograms = async () => {
      try {
        const res = await api.getAllProgramOptions(); // ambil list dari master_third_tier_program
        setPrograms(res);
      } catch (err) {
        console.error('Gagal memuat program:', err);
        showToast('Gagal memuat daftar program.', 'danger');
      } finally {
        setLoading(false);
      }
    };
    fetchPrograms();
  }, [showToast]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.programId || !form.batch || !form.startDate || !form.endDate) {
      showToast('Harap lengkapi semua data sebelum menyimpan.', 'danger');
      return;
    }
    try {
      setSubmitting(true);
      await api.addBatch({
        programId: form.programId,
        batch: form.batch,
        startDate: form.startDate,
        endDate: form.endDate,
        statusOffered: form.statusOffered,
        isOpen: form.isOpen,
      });
      showToast('Batch berhasil ditambahkan!', 'success');
      navigate('/batch');
    } catch (err) {
      console.error(err);
      showToast('Terjadi kesalahan saat menyimpan data.', 'danger');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container py-4" style={{ maxWidth: '720px' }}>
      {/* Back Button */}
      <div className="mb-3">
        <button
          type="button"
          className="btn btn-white btn-sm rounded-circle shadow-sm border bg-white text-dark d-inline-flex align-items-center justify-content-center"
          style={{ width: '38px', height: '38px' }}
          onClick={() => navigate(-1)}
        >
          <i className="bi bi-arrow-left fs-5"></i>
        </button>
      </div>

      {/* HEADER */}
      <div className="mb-4">
        <h3 className="fw-bold">Tambah Batch Baru</h3>
        <p className="text-muted">
          Pilih program, tentukan nama batch, dan atur periode waktu pelaksanaan.
        </p>
      </div>

      <div className="card border-0 shadow-sm rounded-4">
        <div className="card-body p-4">
          {loading ? (
            <div className="text-center py-5">
              <div
                className="spinner-border text-primary"
                style={{ width: '3rem', height: '3rem' }}
                role="status"
              ></div>
              <p className="text-muted mt-3 mb-0">Memuat daftar program...</p>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="row g-3">
              {/* Program Selection */}
              <div className="col-12">
                <label className="form-label fw-semibold">Pilih Program <span className="text-danger">*</span></label>
                <select
                  name="programId"
                  className="form-select rounded-3"
                  value={form.programId}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Pilih Program --</option>
                  {programs.map((p) => (
                    <option key={p.id} value={p.id}>
                      {p.label}
                    </option>
                  ))}
                </select>
              </div>

              {/* Batch Name */}
              <div className="col-12">
                <label className="form-label fw-semibold">Nama Batch <span className="text-danger">*</span></label>
                <input
                  type="text"
                  name="batch"
                  className="form-control rounded-3"
                  value={form.batch}
                  onChange={handleChange}
                  placeholder="Contoh: 10"
                  required
                />
              </div>

              {/* Start & End Date */}
              <div className="col-md-6">
                <label className="form-label fw-semibold">Tanggal Mulai <span className="text-danger">*</span></label>
                <input
                  type="date"
                  name="startDate"
                  className="form-control rounded-3"
                  value={form.startDate}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-6">
                <label className="form-label fw-semibold">
                  Tanggal Selesai <span className="text-danger">*</span>
                </label>
                <input
                  type="date"
                  name="endDate"
                  className="form-control rounded-3"
                  value={form.endDate}
                  onChange={handleChange}
                  required
                />
              </div>

              {/* Status Switches */}
              <div className="col-12 mt-3">
                <div className="form-check form-switch mb-2">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="statusOffered"
                    name="statusOffered"
                    checked={form.statusOffered}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label fw-semibold"
                    htmlFor="statusOffered"
                  >
                    Batch sedang berjalan (Running)
                  </label>

                  <small
                    className="text-muted d-block mt-1"
                    style={{ fontSize: '0.875rem' }}
                  >
                    Jika kamu mengaktifkan opsi ini, sistem akan menganggap batch ini sedang aktif.
                  </small>
                </div>

                <div className="form-check form-switch mb-3">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="isOpen"
                    name="isOpen"
                    checked={form.isOpen}
                    onChange={handleChange}
                  />
                  <label
                    className="form-check-label fw-semibold"
                    htmlFor="isOpen"
                  >
                    Batch dibuka untuk pendaftaran
                  </label>

                  <small
                    className="text-muted d-block mt-1"
                    style={{ fontSize: '0.875rem' }}
                  >
                    Jika kamu menyalakan opsi ini, batch akan muncul di sistem pendaftaran Campus Leader Program.
                  </small>
                </div>
              </div>

              {/* Action Buttons */}
              <div className="d-flex justify-content-end mt-4">
                <button
                  type="button"
                  className="btn btn-light me-2 rounded-pill"
                  onClick={() => navigate('/batch')}
                  disabled={submitting}
                >
                  Batal
                </button>
                <button
                  type="submit"
                  className="btn btn-primary rounded-pill px-4"
                  disabled={submitting}
                >
                  {submitting ? (
                    <>
                      <span
                        className="spinner-border spinner-border-sm me-2"
                        role="status"
                      ></span>
                      Menyimpan...
                    </>
                  ) : (
                    <>
                      <i className="bi bi-save me-2"></i>
                      Simpan
                    </>
                  )}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
